<template>
    <div id="vendorPaymentView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="web-right-sidebar"> <!--right sidebar-->
            <div class="right-asset-tab-list purchase-order-right-tab">
                <div id="tabs" class="containerTab">
                    <div class="tabs">
                        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Payment Details</a>
                        <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity</a>
                    </div>
                    <div class="content">
                        <div v-show="activetab === 1" class="tabcontent">
                            <div class="list-view">
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <!-- <label class="col" >#Check :</label> -->
                                    <label class="col" >#{{ payment_type }} :</label>
                                    <span class="col">{{check_number}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                                    <label class="col">Vendor :</label>
                                    <span class="col">{{vendor}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <label class="col">Payment Type :</label>
                                    <span class="col">{{payment_type}}</span>
                                </div>

                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                                    <label class="col">Payment Date :</label>
                                    <span class="col">{{payment_date}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <label class="col">Status :</label>
                                    <span class="col">{{payment_status}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <label class="col">Amount :</label>
                                    <span class="col">{{payment_amount}}</span>
                                </div>
                            </div>
                        </div>
                        <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                            <vendor-payment-activity-log-list :activityLogVal="activityLogsTabValue"></vendor-payment-activity-log-list>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area purchase-order-left-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name purchase-order-title">
                    <div class="page-title"> # {{payment_number}}</div>
                    <!-- <router-link class="btn btn-secondary pull-right" v-bind:to="{name: 'VendorPaymentList'}"> <i class="fp-back"></i> Back</router-link> -->
                    <div class="btn-groups text-right">
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="backButton" >
                            <i class="fp-back"> </i>    Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div id="workorder-detail work-order-view-top" class="admin-page-content">
                        <section class="internal-container purchase-order-btm bill-view-table border-top-table-fl">
                            <template v-if="paymentItems.length == 0 || paymentItems == undefined">
                                <div class="lineitem-main-section">
                                    <h5>No Line Item Added</h5>
                                </div>
                            </template>
                            <template v-else>
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered purchase-order-item-table">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Invoice Date</th>
                                                <th>Invoice Number</th>
                                                <th>Payment Message </th>
                                                <th class="text-right">Amount</th>
                                                <th class="text-right">Discount</th>
                                                <th class="text-right">Net Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in paymentItems" v-bind:key="index">
                                                <td> {{ item.bill_date}} </td>
                                                <td> {{ item.bill_number}} </td>
                                                <td> {{ item.payment_message}} </td>
                                                <td class="text-right"> {{ item.bill_amount}} </td>
                                                <td class="text-right"> {{ item.bill_discount}} </td>
                                                <td class="text-right"> {{ item.bill_net_amount}} </td>
                                            </tr>
                                            <tr>
                                                <td colspan="4"> </td>
                                                <td> Total </td>
                                                <td class="text-right">{{payment_total}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                        </section>
                        <!-- Journals -->
                        <section class="internal-container border-top-table-fl mt-4" v-if="glArr.length > 0">
                            <div class="journal-title">
                                <h5> General Ledger <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#demo'"></i>   </h5>
                            </div>
                            <div :id="'demo'" class="accordian-body collapse show">
                                <div class="table-reponsive-sm">
                                    <table aria-describedby="table" class="table table-bordered table-sm purchase-order-item-table font-1"  id="workOrder-table" style="border-collapse:collapse;">
                                        <thead>
                                            <tr class="table-primary">
                                                <th>Account</th>
                                                <th class="text-right">Debit</th>
                                                <th class="text-right">Credit</th>
                                                <th class="text-right">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="glArr != undefined && glArr.length > 0">
                                            <template v-for="(journalItem , journalKey) in glArr">
                                                    <tr :key="'journal'+journalKey">
                                                        <template v-if="journalItem.account_description == 'Total'">
                                                            <td style="text-align: right;">{{journalItem.account_description}}</td>
                                                        </template>
                                                        <template v-else>
                                                            <td>{{journalItem.account_description}}</td>
                                                        </template>
                                                        <td style="text-align: right;">{{journalItem.debit}}</td>
                                                        <td style="text-align: right;">{{journalItem.credit}}</td>
                                                        <td style="text-align: right;">{{journalItem.journal_amount}}</td>
                                                    </tr>
                                            </template>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="4"><h5>No GL Found</h5></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                    </section>
                    </div>
                </div>
            </template>

            <template v-else-if="cantAccessPage === false">
            <div class="col-md-12">
                <div class="error-template">
                    <h1>Oops!</h1>
                    <h2>403</h2>
                    <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                </div>
            </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../mixins/commonMixins';
import ActivityLogListView from '@/components/ActivityLogList.vue';

Vue.component("vendor-payment-activity-log-list", ActivityLogListView);
export default {
    name: "VendorPaymentView",
    // metaInfo: {
    //     // title will be injected into parent titleTemplate
    //     title: "Vendor Payment View  | " +process.env.COPYRIGHT_NAME
    // },
    
    mixins:[commonMixins],
    data: () => ({
        loading:false,
        permissions:[],
        cantAccessPage:"",
        paymentId : 0,
        activetab: 1,
        payment_number:'',
        payment_status:'',
        check_number:'',
        payment_date:'',
        vendor:'',
        payment_amount:'',
        payment_type:'',
        payment_total:'',
        paymentItems:[],
        activityLogsTabValue: "vendorPaymentloadList",
        type:'check',
        glArr:[],
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_vendor_payment') {
                    self.cantAccessPage = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function() {
        var self = this;
        self.paymentId = this.$route.params.id;
        self.getPermissions();
        self.loadPaymentData();
    },
    metaInfo() {
        return {
            title: (this.payment_number != "") ? this.payment_number + " | Vendor Payment View | " +process.env.COPYRIGHT_NAME:"Vendor Payment View | " +process.env.COPYRIGHT_NAME
        }
    },
    methods : {
        backBtn(){
            var self = this;
            self.$router.push("/vendor-payment/list");
        },
        loadPaymentData() {
            var self = this;
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vendor-payment/" + self.paymentId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {
                        self.payment_number = data.content.payment_number;
                        if ( data.content.check_number != null) {
                            self.check_number = data.content.check_number;
                        }else{
                            self.check_number = "-";
                        }
                        self.vendor = data.content.vendor;
                        self.payment_type = data.content.payment_type;
                        self.payment_date = data.content.payment_date;
                        self.payment_status = data.content.payment_status;
                        self.payment_amount = data.content.amount;
                        self.payment_total = data.content.payment_amount;
                        self.type = data.content.pay_type;
                        if (data.content.payment_items != undefined) {
                            self.paymentItems = data.content.payment_items;
                        }else{
                            self.paymentItems = [];
                        }
                        if (data.content.gl != undefined) {
                            self.glArr = data.content.gl;
                        }else{
                            self.glArr = [];
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'vendor-payment-view');
                }
            });
        },
        activityLogs(){

            var self = this;

            self.$root.$emit('activity_log_opted','vendor payment',self.paymentId);
            self.activityLogsTabValue = "vendorPaymentloadList";     // flag value set to loadList so that filters in list work properly.
            self.activetab = 2;
        },
        backButton(){
          var self = this;
          var url = '/vendor-payment/list';
          if(self.$route.query.from != undefined && self.$route.query.from == "gl" ){
            self.$router.push('/report/general-ledger');
            return;
          }else{
            self.redirectPageUrl(url);
          }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/payment/VendorPaymentView.vue